// eslint-disable-next-line
import { FC } from "react";
import { Pedido } from "src/components/vendas/types";
import { Box, Button, Icon, Typography } from "@mui/material";
import "../styles.css";

interface SugestaoLayoutProperties {
  children?: React.ReactNode
}

const SugestaoLayout: FC<SugestaoLayoutProperties> = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#ECF7EE",
        borderBottom: "2px solid",
        borderColor: "success.main",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "center", md: "flex-start" },
        justifyContent: "space-between",
        gap: 2,
        p: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
          width: { xs: "100%", md: "80%" },
          textAlign: "left",
        }}
      >
        <Typography
          sx={{
            color: "success.main",
            fontWeight: 600,
          }}
        >
          PRÓXIMA AÇÃO DISPONÍVEL
        </Typography>

        <Typography>
          Este projeto já está pronto para avançar para a próxima etapa do processo
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: { xs: "center", md: "flex-end" },
          mt: { xs: 1, md: 0 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export { SugestaoLayout }
